/**
 * Canonical list of Amplitude Experiment flag keys.
 * Single source of truth for valid experiment flag names.
 */
export const ExperimentFlags = {
  EebPlacement: 'eeb-placement-ocpt-860',
} as const

export type ExperimentFlag =
  (typeof ExperimentFlags)[keyof typeof ExperimentFlags]

/**
 * Variant values for the EEB placement experiment.
 * - `Wizard` (A, control): EEB booking stays a required onboarding step.
 * - `Mainscreen` (B): EEB booking is removed from onboarding and placed as a
 *   mainscreen task.
 */
export const EebPlacementVariant = {
  Wizard: 'wizard',
  Mainscreen: 'mainscreen',
} as const
